export const CADENCE_OPTIONS = [
  'Weekly',
  'Biweekly',
  'Monthly',
  'Quarterly',
  'Yearly',
  'Unknown',
] as const;

export type ReportCadence = (typeof CADENCE_OPTIONS)[number];

export interface UpdateReportPreferencesRequest {
  accounts: ReportCadence[];
  positions: ReportCadence[];
  transactions: ReportCadence[];
  beneficiary: ReportCadence[];
}

export interface ReportPreferences extends UpdateReportPreferencesRequest {
  representativeCode: string;
}
